import { Component, EventEmitter, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { UsersService } from 'src/app/private/services/users.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { SignatureModelComponent } from "../signature-model/signature-model.component";

@Component({
  selector: 'app-user-profile',
  imports: [SharedModule, SignatureModelComponent],
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.scss'
})
export class UserProfileComponent {

  @Output() closeDialog = new EventEmitter<any>();
  isSubmitted = false;
  user: any = {};
  departmentsList: any;
  roles: any;
  isLoading = false;
  showSignatureModal = false;
  signatures: any[] = [];
  selectedIndex: number | null = null;
  signatureDataToEdit: any;
  editSignatureIndex: number | null = null;
  singatureAction: string = 'Create';


  constructor(private api: UsersService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    // this.getUser();
    // this.getAllDepartments();
    // this.getAllRoles();
  }

  prefixOptions = [
    { label: 'Select', value: '' },
    { label: 'Mr', value: 'Mr' },
    { label: 'Ms', value: 'Ms' },
    { label: 'Mrs', value: 'Mrs' }
  ];

  genderOptions = [
    { label: 'Select', value: '' },
    { label: 'Male', value: 'Male' },
    { label: 'Female', value: 'Female' },
    { label: 'Other', value: 'Other' }
  ];

  statusOptions = [
    { label: 'Select', value: '' },
    { label: 'Active', value: 'Active' },
    { label: 'Inactive', value: 'Inactive' },
    { label: 'Suspended', value: 'Suspended' }
  ];

  // getAllRoles() {
  //   const payload = {
  //     organization_id : this.localStorage.getOrganizationId()
  //   }
  //   this.api.getAllRoles(payload).subscribe({
  //     next: (res) => {
  //       this.roles = res|| []
  //     },
  //     error: (e) => {

  //     }
  //   })
  // }

  // getAllDepartments() {
  //   const payload = {
  //     organization_id : this.localStorage.getOrganizationId()
  //   }
  //   this.api.getAllDepartment(payload).subscribe({
  //     next: (res) => {
  //       this.departmentsList = res || []
  //       this.departmentsList = this.departmentsList.map((department: any) => {
  //         return {
  //           label: department.name,
  //           value: Number(department.dept_id)
  //         }
  //       }
  //       )
  //     },
  //     error: (e) => {

  //     }
  //   })
  // }

  // getUser() {
  //   const params = {
  //     user_id: this.localStorage.getUserId(),
  //   };

  //   this.api.getUser(params).subscribe({
  //     next: (res: any) => {
  //       this.user = res;
  //       this.signatures = res.user_sign?.map((sign: any) => sign.signature);
  //       this.selectedIndex = res.user_sign?.findIndex((sign: any) => sign.isActive);
      
  //     },
  //     error: (e: any) => {
  //       console.log(e);
  //     },
  //   });
  // }


  // saveUser(isValid: any) {
  //   this.isSubmitted = true;
  //   if (isValid) {
  //     this.isLoading = true;

  //     const { password, ...userWithoutPassword } = this.user;


  //     let user_sign: any[] = [];

  //     this.signatures.forEach((element, index) => {
  //       user_sign.push({
  //         signature: element,
  //         isActive: index === this.selectedIndex ? true : false
  //       })
  //     }
  //     );

  //     console.log("user_sign", user_sign);

  //     const payload = {
  //       ...userWithoutPassword,
  //       user_sign: user_sign,
  //     };

  //     this.api.updateUser(payload).subscribe({
  //       next: (res: any) => {
  //         this.getUser();
  //         this.handleCloseDialog();
  //         localStorage.setItem('user_sign', JSON.stringify(user_sign));
  //         // this.toast.success("User Updated Successfully", 'Success')
  //         this.messageService.add({ severity: 'success', summary: 'Success', detail: 'User Updated Successfully' });
  //         this.isLoading = false;
  //       },
  //       error: (e: any) => {
  //         this.messageService.add({ severity: 'error', summary: 'Error', detail: (e.error.msg ||
  //           'Something went wrong, Please try again later'
  //         ) });
  //         this.isLoading = false;
  //       }
  //     })
  //   }
  // }

  openSignatureModal() {
    this.singatureAction = 'Create';
    this.showSignatureModal = true;
  }

  handleCloseSignatureModel() {
    this.showSignatureModal = false;
  }

  
  handleCloseDialog() {
    this.closeDialog.emit();
  }

  EditSignatureModal(index: number) {
    this.showSignatureModal = true;
    this.signatureDataToEdit = this.signatures[index];
    this.editSignatureIndex = index;
    this.singatureAction = 'Update';
  }

  deleteSignature(index: number) {
    this.signatures.splice(index, 1);
  }

  updateSignaturesData(signature: string) {
    this.signatures.push(signature);
  }

  editSignatureValue(signature: any) {
    if (this.editSignatureIndex !== null) {
      this.signatures[this.editSignatureIndex] = signature;
    }
  }



}
